import { render, staticRenderFns } from "./LoyalityCheckInCongratulations.vue?vue&type=template&id=1a470f68&scoped=true"
import script from "./LoyalityCheckInCongratulations.vue?vue&type=script&lang=js"
export * from "./LoyalityCheckInCongratulations.vue?vue&type=script&lang=js"
import style0 from "./LoyalityCheckInCongratulations.vue?vue&type=style&index=0&id=1a470f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a470f68",
  null
  
)

export default component.exports